import React from 'react';
import PropTypes from 'prop-types';

import styles from '../styles.scss';

export default class StatusLog extends React.PureComponent {
  static propTypes = {
    newStatus1Name: PropTypes.string.isRequired,
    Status1Comment: PropTypes.string.isRequired,
    newStatus2Name: PropTypes.string.isRequired,
    Status2Comment: PropTypes.string.isRequired,
  };

  render() {
    const { Status1Comment, newStatus1Name, Status2Comment, newStatus2Name } = this.props;
    return (
      <div className={styles.body}>
        <div className={styles.status}>
          <div className={styles.statusNameText}>установлен статус</div>
          <div className={styles.statusName}>{newStatus1Name}</div>
        </div>
        {Status1Comment && (
          <div className={styles.statusComment}>
            <div className={styles.statusNameText}>оставлен комментарий статуса:</div>
            <div className={styles.statusCommentName}>{Status1Comment}</div>
          </div>
        )}
        {newStatus2Name && (
          <div className={styles.status}>
            <div className={styles.statusNameText}>установлен подстатус</div>
            <div className={styles.subStatusName}>{newStatus2Name}</div>
          </div>
        )}
        {Status2Comment && (
          <div className={styles.statusComment}>
            <div className={styles.statusNameText}>оставлен комментарий подстатуса:</div>
            <div className={styles.statusCommentName}>{Status2Comment}</div>
          </div>
        )}
      </div>
    );
  }
}
